import React from "react";
import EventPriceBadge from "./EventPriceBadge";

/**
 * Shared event-card Price row: "Price:" + Free (green) / amount (gold) badge.
 * Place with other card-meta fields (Hosted By, Audience Type, …).
 */
export default function EventCardPriceMeta({ event }) {
  if (!event) return null;
  return (
    <div className="card-meta">
      <span className="card-meta-label">Price:</span>
      <EventPriceBadge event={event} />
    </div>
  );
}
